module.exports = __webpack_public_path__ + "static/media/arrow-left.82fe6cf9.svg";